import React, { useState } from "react";
import LocationInputSimple from "../LocationInputSimple";

const StaySearchFormSimple: React.FC = () => {
  const [selectedLocation, setSelectedLocation] = useState("");

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedLocation) return;
    console.log("Searching for:", selectedLocation);
  };

  return (
    <div className="flex flex-col items-center w-full mt-10 px-4">
      <form
        onSubmit={handleSearch}
        className="w-full max-w-md"
      >
        <LocationInputSimple
          value={selectedLocation}
          setValue={setSelectedLocation}
        />
      </form>
    </div>
  );
};

export default StaySearchFormSimple;
